<template>
  <div class="position-relative w-100" :style="{ zIndex: isFocus ? 1000 : 1 }">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      :value="query || displayText"
      @input="onSearchInput"
      :placeholder="placeholderText"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <div class="select-input-body-wrapper">
      <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
        <v-icon v-if="selectedItems.length > 0 && !isFocus" name="buttons/cross" :size="11"/>
        <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
        <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
      </button>
    </div>

    <div v-if="isFocus" class="custom-dropdown-select" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="checkItem(item)"
        >
          <b-form-checkbox
            :checked="isSelected(item.id)"
            class="text-small m-0"
            style="pointer-events: none;"
          >
            {{ item.name }}
          </b-form-checkbox>
        </div>
      </div>

      <div v-if="filteredItems.length > 0 && canCreateCatalog && catalogName" class="custom-dropdown-select-footer p-1 border-top">
        <b-btn class="custom-btn-primary mt-0" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
        <b-btn v-if="canCreateCatalog && catalogName" class="custom-btn-primary mt-2" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogMultiSelect",
  props: {
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    value: { type: Array, default: null },
    initialValue: { type: Array, default: null },
    catalogName: { type: String, default: "" },
    getList: { type: Function, default: null },
    options: { type: Array, default: () => [] },
    canCreateCatalog: { type: Boolean, default: false },
    dropUp: { type: Boolean, default: false },
    placeholder: { type: String, default: "" }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selectedItems: [],
    }
  },
  computed: {
    currentValue() {
      return this.value !== null ? this.value : (this.initialValue || []);
    },
    availableItems() {
      const source = this.getList ? this.items : this.options;
      return source.map(item => ({
        id: item.id !== undefined ? item.id : item.value,
        name: item.name !== undefined ? item.name : (item.text || '')
      }));
    },
    filteredItems() {
      const q = this.query ? this.query.trim().toLowerCase() : '';
      return q ? this.availableItems.filter(i => i.name.toLowerCase().includes(q)) : this.availableItems;
    },
    displayText() {
      if (this.selectedItems.length === 0) return "";
      const names = this.selectedItems.map(i => i.name);
      return names.length <= 3 ? names.join(", ") : `Выбрано: ${names.length}`;
    },
    placeholderText() {
      if (this.placeholder) return this.placeholder;
      return this.availableItems.length === 0 && this.catalogName ? `Создайте ${this.catalogName}` : `Выберите...`;
    }
  },
  watch: {
    currentValue: {
      handler: 'syncSelection',
      immediate: true
    },
    availableItems: {
      handler: 'syncSelection'
    }
  },
  mounted() {
    if (this.getList) this.getItems();
  },
  methods: {
    async getItems() {
      this.items = await this.getList() || [];
    },
    syncSelection() {
      this.selectedItems = this.availableItems.filter(item => this.currentValue.includes(item.id));
    },
    isSelected(id) {
      return this.selectedItems.some(item => item.id === id);
    },
    onSearchInput(value) {
      this.query = value;
    },
    onFocusIn() {
      this.isFocus = true;
      this.query = '';
    },
    onFocusOut() {
      this.isFocus = false;
      this.query = '';
    },
    onClick() {
      if (this.selectedItems.length > 0 && !this.isFocus) {
        this.onClear();
      } else {
        this.isFocus ? this.onFocusOut() : this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    checkItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      let newIds = [...this.currentValue];

      if (index > -1) {
        newIds = newIds.filter(id => id !== item.id);
      } else {
        newIds.push(item.id);
      }
      this.emitChanges(newIds);
      this.$refs.input_ref.$el.focus();
    },
    onClear() {
      this.query = '';
      this.emitChanges([]);
    },
    emitChanges(ids) {
      this.$emit('input', ids);
      this.$emit('onSelect', ids);
    },
    showModalCatalog() {
      this.isFocus = false;
      this.$emit('open-modal');
    },
    onItemCreated(newItem) {
      const id = newItem.id !== undefined ? newItem.id : newItem.value;
      if (this.getList) {
        this.items.push(newItem);
      }
      this.emitChanges([...this.currentValue, id]);
    }
  }
}
</script>

<style scoped>
.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CatalogMultiSelect.vue